var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 6 3 L 6 29 L 26 29 L 26 9.59375 L 25.71875 9.28125 L 19.71875 3.28125 L 19.40625 3 Z M 8 5 L 18 5 L 18 11 L 24 11 L 24 27 L 8 27 Z M 20 6.4375 L 22.5625 9 L 20 9 Z M 11 13 L 11 15 L 21 15 L 21 13 Z M 11 17 L 11 19 L 21 19 L 21 17 Z M 11 21 L 11 23 L 21 23 L 21 21 Z"}));
}

File.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = File;

File.default = File;
